import { useTranslation } from "react-i18next";
import Select from "../../common/components/Select";
import useClientConfig from "../../common/hooks/clientConfigHook";
import PropTypes from 'prop-types';

export const customCtrlDef = {
    toString: ({ value, defaultValue, clientConfig }) => {
        return clientConfig.patientAcuities.find(a => a.value == value)?.label ?? value;
    },
    control: ({ value, ...props }) => <EpcrAcuityDropdown acuity={value} {...props}></EpcrAcuityDropdown>
};

const EpcrAcuityDropdown = ({acuity, hideLabel = false, placeholder, disabled = false, required = false, onChange}) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();

    return <Select hideLabel={hideLabel} disabled={disabled} required={required} placeholder={(placeholder ?? t('patientAcuity')) + (required ? ' *' : '')} value={acuity} onChange={onChange} options={clientConfig.patientAcuities} labelField="label" valueField="value"></Select>
}

EpcrAcuityDropdown.propTypes = {
    acuity: PropTypes.string,
    hideLabel: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    onChange: PropTypes.func
}

export default EpcrAcuityDropdown;